<template>
  <v-row class="d-flex justify-center">
    <v-col cols="12" sm="12" md="3">
      <card-multitarefas
        nome="Clientes"
        placeholder="Buscar clientes..."
        :items="[]"
        tipo="cliente"
        @changeInput="buscarCliente"
        @next="next"
        @save="criarCliente"
        :hasSelecionado="true"
        :hasChangeInput="true"
        :hasNext="true"
        :hasEdit="false"
      />
    </v-col>

    <v-col cols="12" sm="12" md="3">
      <card-multitarefas
        nome="Produtos"
        placeholder="Novo produto..."
        :items="produtosA"
        tipo="produto"
        @next="next"
        @deleteItem="deleteItem"
        @save="criarProduto"
        @edit="editarProduto"
        :hasSelecionado="clienteSelecionado.selecionado"
        :hasNext="true"
        :hasEdit="true"
      />
    </v-col>

    <v-col cols="12" sm="12" md="3">
      <card-multitarefas
        nome="Subprodutos"
        placeholder="Novo subproduto..."
        :items="subProdutosA"
        tipo="subproduto"
        @deleteItem="deleteItem"
        @save="criarSubProduto"
        @edit="editarSubProduto"
        :hasSelecionado="produtoSelecionado.selecionado"
        :hasNext="false"
        :hasEdit="true"
      />
    </v-col>

    <v-dialog
      v-model="hasErrorDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-card-text >
            <h1 class="transition-swing text-h1 mb--1 d-flex justify-center w-100 error__delete_title">
              OPS!
            </h1>
            <p class="font-weight-medium d-flex justify-center mt-10 error__delete_text">
              Ocorreu um erro no processamento!
            </p>
            <p class="font-weight-medium d-flex justify-center error__delete_text">
              Verifique se não há registros vinculados a este {{errorName}}!
            </p>
          </v-card-text>
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="hasErrorDelete = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEdit"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-card-text >
            <h3 class="transition-swing text-h3 mb--1">
              Editar
            </h3>
            
          </v-card-text>
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="dialogEdit = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-row>
</template>

<style lang="scss">
  .error__delete_title {
    color: #ff5252;
  }
  .error__delete_text {
    color: #545454;
  }
</style>

<script>
import { mapState, mapActions } from 'vuex'

import CardMultitarefas from '../../CardMultitarefas/CardMultitarefas.vue'

export default {
  name: 'GestaoClienteProdutos',
  components: {
    CardMultitarefas
  },

  data () {
    return {
      clienteSelecionado: {
        data: {},
        selecionado: false
      },
      produtoSelecionado: {
        data: {},
        selecionado: false
      },
      subProdutoSelecionado: {
        data: {},
        selecionado: false
      },
      selecionadoDefault: {
        data: {},
        selecionado: false
      },
      ultimoProdutoCriado: {},
      ultimoSubProdutoCriado: {},
      hasErrorDelete: false,
      errorName: 'pátio',
      dialogEdit: false
    }
  },

  computed: {
    ...mapState('patio', ['patios', 'terminais', 'produtos']),
    ...mapState('subProdutos', ['subProdutos']),
    ...mapState('auth', ['empresaAtual']),

    produtosA () {
      if (this.clienteSelecionado.selecionado) {
        const produto = this.produtos.filter(produto => produto.terminal === this.clienteSelecionado.data.id)
        return produto
      } else {
        return []
      }
    },

    subProdutosA () {
      if (this.produtoSelecionado.selecionado) {
        const subProduto = this.subProduto.filter(subProduto => subProduto.produto === this.produtoSelecionado.data.id)
        return subProduto
      } else {
        return []
      }
    }
  },

  created() {
    this.getProduto()
    this.getSubProduto()

  },

  methods: {
    ...mapActions('patio', [
        'getProduto',
        'addProduto', 'addSubProduto',
        'deleteProduto', 'deleteSubProduto'
      ]),
    ...mapActions('subProdutos', ['getSubProduto']),

    next(item, tipo) {
      if (tipo === "cliente") {
        if (this.clienteSelecionado.data.id !== item.id) {
          Object.assign(this.produtoSelecionado, this.selecionadoDefault)
          Object.assign(this.subProdutoSelecionado, this.selecionadoDefault)
        }
        this.clienteSelecionado.selecionado = true
        this.clienteSelecionado.data = item
      }
      if (tipo === "produto") {
        if (this.produtoSelecionado.data.id !== item.id) {
          Object.assign(this.subProdutoSelecionado, this.selecionadoDefault)
        }
        this.produtoSelecionado.selecionado = true
        this.produtoSelecionado.data = item
      }
    },

    async deleteItem(id, tipo) {
      let result
      switch (tipo) {
        case 'produto':
          result = await this.deleteProduto(id)
          break;
        case 'subproduto':
          result = await this.deleteSubProduto(id)
          break;
      }

      if (!result) {
        this.errorName = tipo
        this.hasErrorDelete = true
      }
    },

    async buscarCliente (data) {
      
      console.log(data)
    },

    async criarProduto (data) {
      data.proprietario = this.empresaAtual.id
      data.terminal = this.terminalSelecionado.data.id
      await this.addProduto(data)
      await this.getProduto(this.empresaAtual.id)
    },

    async criarSubProduto (data) {
      data.proprietario = this.empresaAtual.id
      data.produto = this.produtoSelecionado.data.id
      await this.addSubProduto(data)
      await this.getSubProduto(this.empresaAtual.id)
    },

    criarCliente () {
      console.log('criar cliente')
      this.$router.push({
          name: 'Empresas',
          params: {
            irParaCadastro: true
          }
      }) 
    },

    editarProduto (item) {
      console.log(item)
      this.dialogEdit = true
    },

    editarSubProduto (item) {
      console.log(item)
      this.dialogEdit = true
    },

  }
}
</script>